// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import FileUploadController from "./file_upload_controller"
application.register("file-upload", FileUploadController)
